import { IconProps } from ".";

export const AptosIcon: React.FC<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.4925 6.693H13.7229C13.5184 6.693 13.3222 6.6057 13.1845 6.45189L12.4666 5.6454C12.3581 5.52484 12.2078 5.45417 12.0451 5.45417C11.8823 5.45417 11.7321 5.52484 11.6235 5.6454L11.0058 6.33964C10.8055 6.56413 10.5134 6.69716 10.2129 6.69716H0.525877C0.250417 7.47454 0.0709516 8.30181 0 9.16234H9.14441C9.30718 9.16234 9.45743 9.09583 9.57012 8.97943L10.4215 8.09396C10.5259 7.98171 10.6761 7.91936 10.8264 7.91936H10.8598C11.0225 7.91936 11.1728 7.99003 11.2813 8.11059L11.9992 8.91707C12.1369 9.07089 12.3331 9.15819 12.5376 9.15819H20C19.929 8.30181 19.7496 7.47039 19.4741 6.68884L15.4925 6.693Z"
        fill="white"
        style={{
          fill: "currentColor",
          fillOpacity: "1"
        }}
      />
      <path
        d="M5.53422 14.3505C5.697 14.3505 5.84725 14.2839 5.95993 14.1675L6.81135 13.2821C6.91987 13.1698 7.06594 13.1075 7.22037 13.1075H7.25376C7.41653 13.1075 7.57095 13.1781 7.67529 13.2945L8.39316 14.101C8.53089 14.2548 8.72705 14.3421 8.93155 14.3421H19.0484C19.4282 13.5606 19.7037 12.725 19.8706 11.8479H10.1586C9.95409 11.8479 9.75793 11.7606 9.6202 11.6067L8.90234 10.8086C8.79382 10.688 8.64357 10.6215 8.4808 10.6215C8.31803 10.6215 8.16361 10.6922 8.05927 10.8086L7.44157 11.5028C7.24124 11.7315 6.94908 11.8603 6.64441 11.8603H0.13773C0.304674 12.7375 0.580134 13.5731 0.959933 14.3546L5.53422 14.3505Z"
        fill="white"
        style={{
          fill: "currentColor",
          fillOpacity: "1"
        }}
      />
      <path
        d="M12.7087 3.99501C12.8715 3.99501 13.0217 3.9285 13.1344 3.8121L13.9858 2.92663C14.0901 2.81439 14.2404 2.75203 14.3948 2.75203H14.4282C14.591 2.75203 14.7412 2.8227 14.8497 2.94326L15.5676 3.7539C15.7053 3.90771 15.9015 3.99501 16.106 3.99501H18.03C16.1978 1.56724 13.2846 0 10.0042 0C6.72371 0 3.80634 1.56724 1.97412 3.99501H12.7087Z"
        fill="white"
        style={{
          fill: "currentColor",
          fillOpacity: "1"
        }}
      />
      <path
        d="M6.2187 16.824C6.01419 16.824 5.81803 16.7367 5.6803 16.5828L4.96244 15.7764C4.85392 15.6558 4.70367 15.5893 4.5409 15.5893C4.37813 15.5893 4.22371 15.66 4.11937 15.7764L3.50167 16.4706C3.30134 16.6992 3.00918 16.8281 2.70451 16.8281H2.66277C4.49499 18.782 7.10351 20.0083 10.0042 20.0083C12.9048 20.0083 15.5092 18.782 17.3456 16.8281L6.2187 16.824Z"
        fill="white"
        style={{
          fill: "currentColor",
          fillOpacity: "1"
        }}
      />
    </svg>
  );
};
